meedy.factory('meedy.reportService', ['$q', 'meedy.baseService', 'objectHelper', 'meedyConfig',
    function($q, baseService, objectHelper, config) {

	    function ReportService() {

			this.downloadReport = function (reportName, startDate, endDate) {
				return baseService.get(config.API_URL + `/medicalPosts/${reportName}/from/${startDate}/to/${endDate}`, {responseType: 'arraybuffer'}).then(
					function (successResponse) {
						var blob = new Blob([successResponse], {type: "application/vnd.ms-excel"});
						var pdfLink = (window.URL || window.webkitURL).createObjectURL(blob);

						var a = document.createElement('a');
						a.href = pdfLink;
						a.target = '_blank';
						a.download = reportName + '.xlsx';

						document.body.appendChild(a);
						a.click();

						return successResponse;
					},
					function (errorResponse) {
						return $q.reject(errorResponse);
					}
				);
			};
		}
	
	    return new ReportService();
	}
]);
